import { Instance } from 'mobx-state-tree';
import { RouteRecallRevertedDtoModelBase } from './RouteRecallRevertedDtoModel.base';

/* The TypeScript type of an instance of RouteRecallRevertedDtoModel */
export interface RouteRecallRevertedDtoModelType extends Instance<typeof RouteRecallRevertedDtoModel.Type> {}

/* A graphql query fragment builders for RouteRecallRevertedDtoModel */
export { selectFromRouteRecallRevertedDto, routeRecallRevertedDtoModelPrimitives, RouteRecallRevertedDtoModelSelector } from './RouteRecallRevertedDtoModel.base';

/**
 * RouteRecallRevertedDtoModel
 *
 * Route recall reverted event
 */
export const RouteRecallRevertedDtoModel = RouteRecallRevertedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
